import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, IconButton, Select, MenuItem } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight, FirstPage, LastPage } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 10px',
    backgroundColor: isMobile ? 'transparent' : 'rgba(229, 233, 234, .65)',
    borderRadius: '0 0 8px 8px'
  },
  paginationControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    position: isMobile ? 'relative' : 'absolute',
    left: isMobile ? '0%' : '50%',
    transform: isMobile ? 'none' : 'translateX(-50%)'
  },
  paginationText: {
    fontSize: '14px',
    color: '#888B8D',
    fontFamily: 'Sura Sans, system-ui'
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1
  },
  paginationCircles: {
    display: 'flex',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    gap: '8px'
  },
  circle: {
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans, system-ui',
    color: '#0033A0',
    backgroundColor: '#FFFFFF',
    '&.active': {
      backgroundColor: '#2D6DF6',
      color: '#FFFFFF',
      border: 'none'
    }
  }
});

const PaginationPaymentDetail = ({ 
  classes, 
  filteredReceipts, 
  page, 
  rowsPerPage, 
  paymentData,
  onChangePage, 
  onChangeRowsPerPage 
}) => {

  const renderPaginationCircles = () => {
    if (!paymentData) {
      return null;
    }

    if (!paymentData.pagination) {
      return null;
    }
    
    const { total, page: currentPage, limit } = paymentData.pagination;
    
    if (!total || !currentPage || !limit) {
      return null;
    }
    
    const totalPages = Math.ceil(total / limit);
    
    if (totalPages <= 0) {
      return null;
    }
    
    const paginationItems = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        paginationItems.push(
          <li
            key={i}
            className={`${classes.circle} ${i === currentPage ? 'active' : ''}`}
            onClick={() => onChangePage(null, i)}
          >
            {i}
          </li>
        );
      }
    } else {
      paginationItems.push(
        <li
          key={1}
          className={`${classes.circle} ${1 === currentPage ? 'active' : ''}`}
          onClick={() => onChangePage(null, 1)}
        >
          1
        </li>
      );

      if (currentPage <= 3) {
        for (let i = 2; i < maxVisiblePages; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === currentPage ? 'active' : ''}`}
              onClick={() => onChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
        paginationItems.push(
          <li key="end-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        paginationItems.push(
          <li
            key={totalPages}
            className={`${classes.circle} ${totalPages === currentPage ? 'active' : ''}`}
            onClick={() => onChangePage(null, totalPages)}
          >
            {totalPages}
          </li>
        );
      } else if (currentPage >= totalPages - 2) {
        paginationItems.push(
          <li key="start-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        for (let i = totalPages - 3; i < totalPages; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === currentPage ? 'active' : ''}`}
              onClick={() => onChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
      } else {
        paginationItems.push(
          <li key="start-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === currentPage ? 'active' : ''}`}
              onClick={() => onChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
        paginationItems.push(
          <li key="end-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        paginationItems.push(
          <li
            key={totalPages}
            className={`${classes.circle} ${totalPages === currentPage ? 'active' : ''}`}
            onClick={() => onChangePage(null, totalPages)}
          >
            {totalPages}
          </li>
        );
      }
    }

    return <ul className={classes.paginationCircles}>{paginationItems}</ul>;
  };

  if (!filteredReceipts || filteredReceipts.length === 0) {
    return null;
  }

  return (
    <div className={classes.paginationContainer}>
      <div className={classes.pagination}>
        <IconButton onClick={event => onChangePage(event, 1)} disabled={page === 1}>
          <FirstPage />
        </IconButton>
        <IconButton onClick={event => onChangePage(event, page - 1)} disabled={page === 1}>
          <KeyboardArrowLeft />
        </IconButton>
        {renderPaginationCircles()}
        <IconButton onClick={event => onChangePage(event, page + 1)} disabled={page >= Math.ceil(filteredReceipts.length / rowsPerPage)}>
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={event => onChangePage(event, Math.ceil(filteredReceipts.length / rowsPerPage))}
          disabled={page >= Math.ceil(filteredReceipts.length / rowsPerPage)}
        >
          <LastPage />
        </IconButton>
      </div>
      <div className={classes.paginationControls}>
        <Typography className={classes.paginationText}>Mostrar</Typography>
        <Select
          value={rowsPerPage}
          onChange={onChangeRowsPerPage}
          disableUnderline
          style={{ 
            fontSize: '14px',
            fontFamily: 'Sura Sans',
            borderRadius: '10px',
            backgroundColor: '#F8F8F8',
            padding: '0 6px'
          }}
        >
          <MenuItem value={12}>12</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={30}>30</MenuItem>
          <MenuItem value={40}>40</MenuItem>
        </Select>
        <Typography className={classes.paginationText}>Filas por página</Typography>
      </div>
    </div>
  );
};

export default withStyles(styles)(PaginationPaymentDetail); 


// WEBPACK FOOTER //
// ./src/containers/paymentMovements/components/PaginationPaymentDetail.js